import React from 'react';
import PropTypes from 'prop-types';
import useUserContext from 'Context/UserContext';
import useSimpleHousehold from 'Hooks/useSimpleHousehold';

export const LogoutContext = React.createContext(null);

export function LogoutContextProvider({ children }) {
  const { logout: userLogout } = useUserContext();
  const { clearHousehold } = useSimpleHousehold();

  const logout = React.useCallback(() => {
    clearHousehold();
    userLogout();
  }, [userLogout, clearHousehold]);

  const memoizedValue = React.useMemo(() => {
    return {
      logout,
    };
  }, [
    logout,
  ]);

  return (
    <LogoutContext.Provider
      value={memoizedValue}
    >
      {children}
    </LogoutContext.Provider>
  );
}

LogoutContextProvider.propTypes = {
  children: PropTypes.any.isRequired,
};

export function useLogoutContext() {
  const context = React.useContext(LogoutContext);
  if (!context) throw new Error('useLogoutContext must be called from a LogoutContext.Provider');
  return context;
}
